import React from "react";
import { useFavoriteLinks } from "../../../state/api/links/useFavoriteLinks";
import { Doc } from "../../../types/db/collections";
import { GetLinkResponse } from "../../../types/db/schema/links/link.schema";
import UsefulLink from "../links/UsefulLink";
import PageLoader from "../loader/PageLoader";

export default function FavoritesList() {

  const { favorites, isLoading } = useFavoriteLinks();

  if (isLoading) {
    return <PageLoader />
  }

  if (!favorites?.length) {
    return (
      <div className="p-3">
        <span>No favorites yet. Save a link from our collection to get started.</span>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column gap-2 h-100" style={{ overflowY: "auto" }}>
      {
        favorites.map(f => <UsefulLink key={f._id} link={f as Doc<GetLinkResponse>} />)
      }
    </div>
  )
}